import { t } from "@/i18n-js/instance";
import { IconButton } from "@circle-react-shared/uikit/HeaderV3/IconButton";
import { Typography } from "@circle-react-shared/uikit/Typography";

interface CalendarHeaderProps {
  currentMonth: string | null;
  goNext: () => void;
  goPrev: () => void;
}

export const CalendarHeader = ({
  currentMonth,
  goPrev,
  goNext,
}: CalendarHeaderProps) => (
  <div
    id="calendar-view-header"
    className="bg-primary border-primary flex w-full items-center justify-between rounded-t-md border-x border-t px-5 py-4 sm:px-6 sm:py-5"
  >
    <Typography.LabelMd weight="semibold">{currentMonth}</Typography.LabelMd>
    <div className="flex flex-row gap-3">
      <IconButton
        name="20-chevron-left"
        ariaLabel={t("prev")}
        onClick={goPrev}
        buttonSize={28}
        iconSize={20}
        iconClassName="!h-5 !w-5"
      />
      <IconButton
        name="20-chevron-right"
        ariaLabel={t("next")}
        onClick={goNext}
        buttonSize={28}
        iconSize={20}
        iconClassName="!h-5 !w-5"
      />
    </div>
  </div>
);
